import React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import { withStyles } from "@mui/styles";
import { Box, Button, Typography } from "@mui/material";
import { isLeadSubmitButtonDisabled } from "../../helpers/validation";
import { useStyles } from "./indexStyles";
import { BUTTON_PROCEED, BUTTON_SUBMIT } from "../../constants";

const LeadButton = ({
  classes: { button, buttonText, loaderStyle, mainCta },
  errorMessage,
  form,
  isFormSubmitted,
}) => {
  return (
    <Button
      type="submit"
      size="large"
      variant={"contained"}
      color="primary"
      className={button}
      fullWidth
      {...(isLeadSubmitButtonDisabled(isFormSubmitted, form, errorMessage) && {
        disabled: true,
      })}
    >
      <Box className={buttonText}>
        {!isFormSubmitted ? (
          <Typography variant={"body1"} className={mainCta}>
            {BUTTON_PROCEED}
          </Typography>
        ) : (
          <Typography variant={"body1"} className={mainCta}>
            <CircularProgress
              color={"inherit"}
              className={loaderStyle}
              size={20}
            />
          </Typography>
        )}
      </Box>
    </Button>
  );
};

LeadButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles, { withTheme: true })(LeadButton);
